import { render, staticRenderFns } from "./editProviceAdmin.vue?vue&type=template&id=70d58f9a&scoped=true&"
import script from "./editProviceAdmin.vue?vue&type=script&lang=js&"
export * from "./editProviceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./editProviceAdmin.vue?vue&type=style&index=0&id=70d58f9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d58f9a",
  null
  
)

export default component.exports